import React from 'react';
import { Link } from 'react-router-dom';

import GetInTouchButton from '@app/components/UI/Forms/GetInTouch/GetInTouchButton';
import MiddleText from '@app/components/UI/MiddleText/MiddleText';

const AreaNotFound = ({ isMobile }) => {
	return (
		<div className="areas-list-page__not-found">
			<MiddleText
				title="As it turns out..."
				// eslint-disable-next-line max-len
				text="You're in one of the few areas where we don't have a Lap of Love veterinarian (not yet at least). We are so sorry for this inconvenience. One day we hope to have a doctor available to every family in the United States!"
			/>

			<MiddleText
				title="Schedule a telehospice consultation with a doctor"
				// eslint-disable-next-line max-len
				text="Designed to help guide and support the decision-making process through the tough journey of end-of-life veterinary care, our telehospice calls are often a huge help for pet parents. If you'd like to speak with a hospice veterinarian via phone or video, please reach out today."
			/>

			{isMobile ? (
				<div className="mobile-btns">
					<Link to="/our-services/telehospice" className="btn btn-primary">
						Read More About Telehospice
					</Link>
					<a className="btn btn-md btn-primary" href="tel:855-933-5683">
						Schedule a Telehospice Appointment
					</a>
				</div>
			) : (
				<div className="desktop-btns">
					<Link to="/our-services/telehospice" className="btn btn-primary">
						Read More About Telehospice
					</Link>
					<GetInTouchButton btnText="Schedule a Telehospice Appointment" btnClassName="btn btn-primary" openFormInModal />
				</div>
			)}
		</div>
	);
};

export default AreaNotFound;
